import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class PedidoCampoPersonalizadoSelecionadoService {

  constructor(private http: HttpClient) { }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoCampoPersonalizadoSelecionado/ListarPorPedido',
      { params: new HttpParams().set('id', id) });
  }

  salvar(campos, idCupom) {
    const body = {
      campos: campos,
      idCupom: idCupom
    };

    return this.http.post(globals.apiUrl + '/api/PedidoCampoPersonalizadoSelecionado/Salvar', body);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/PedidoCampoPersonalizadoSelecionado/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
